import { connect } from 'react-redux';
import React from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader

} from "reactstrap";
import { history } from 'helpers';
import Switch from "react-bootstrap-switch";
import { PanelHeader, Button } from "components";
import { Link } from 'react-router-dom';
import ReactJson from 'react-json-view';
import { roleConstants } from '../../constants';
import Select from "react-select";
import User from '../../entities/User'
import { userActions, loopbackActions } from '../../actions';
import { withTranslation } from 'react-i18next';


class UserEdit extends React.Component {

  constructor(props) {
    super(props)

    this.loggedinUser = User.current();
    this.roleOptions = [];  
    let roles = JSON.parse(localStorage.getItem('userroles'));
    const user = props.user || user;
    let selectedRoleOption = null;
    for (var role of roles) {
      let option = { value: role.id, label: role.role }
      this.roleOptions.push(option);
      if (user && user.userRoleId==role.id){
        selectedRoleOption=option;
      }
    }
    this.languageOptions = [
      { value:'ca', label:'Catalano' },
      { value:'cz', label:'Ceco' },
      { value: 'en', label: 'Inglese' },
      { value: 'fr', label: 'Francese' },
      { value: 'it', label: 'Italiano' },
      { value:'sk', label:'Slovacco' },
      { value:'es', label:'Spagnolo' }
    ];

    this.state = {
      user: {
        id: '',
        email: '',
        password: '',
        passwordConfirm: '',
        name: '',
        surname: '',
        emailVerified: true,
        userRoleId: 1,
        isActive: true
      },
      submitted: false,
      modalNotice: false,
      emailState: '',
      nameState: '',
      surnameState: '',
      selectedLanguage: '',
      passwordState: '',
      selectedRoleOption
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    const id = this.props.match.params.id
    this.setState({
      addMode: id == 0
    })
  }

  componentDidMount() {
    const id = this.props.match.params.id
    if (id > 0) {
      this.props.dispatch(loopbackActions.get('admin','users',id, { include: 'projects' } ));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ error: nextProps.error, modalNotice: true });
    }
    else {
      if (nextProps.user) {
          let user = nextProps.user, selectedRoleOption=null;
          user.password = "";
          user.passwordConfirm = "";

          for (let option of this.roleOptions) {
            if (user.userRoleId==option.value){
              selectedRoleOption=option;
              break;
            }
          }

          let selectedLanguage = null;
          for (let option of this.languageOptions) {
            if (user.language == option.value) {
              selectedLanguage = option;
              break;
            }
          }
    
          this.setState({
            user,
            selectedLanguage,
            selectedRoleOption
          });
      }
    }
  }

  handleChange(e) {

    const { name, value } = e.target;

    let user = this.state.user;
    let emailState = "";
    let passwordState = "";

    user[name] = value;

    if (name === 'email') {
      var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (value == '') {
        emailState = "";
      }
      else if (emailRex.test(value)) {
        emailState = "has-success";
      }
      else {
        emailState = "has-danger";
      }
    }
    else if (name === 'password' || name === 'passwordConfirm') {
      if (value == '' && (name === 'password' ? this.state.user.passwordConfirm : this.state.user.password) == '') {
        passwordState = "";
      }
      else if (value == (name === 'password' ? this.state.user.passwordConfirm : this.state.user.password)) {
        passwordState = "has-success";
      }
      else {
        passwordState = "has-danger";
      }
    }
    this.setState({ user, emailState, passwordState });
  }

  handleSubmit(e) {

    e.preventDefault();

    let { user, addMode, selectedRoleOption, selectedLanguage } = this.state;
    let hasValidationErrors = false;

    if (user.email === '') {
      this.setState({ emailState: 'has-danger' });
      hasValidationErrors = true;
    }

    if (user.name == '') {
      this.setState({ nameState: 'has-danger' });
      hasValidationErrors = true;
    }

    if (user.surname == '') {
      this.setState({ surnameState: 'has-danger' });
      hasValidationErrors = true;
    }

    if (addMode && (user.password == '' || user.password != user.passwordConfirm)) {
      this.setState({ passwordState: 'has-danger' });
      hasValidationErrors = true;
    }

    if (hasValidationErrors)
      return;

    this.setState({ submitted: true });

    const { dispatch } = this.props;

    if (selectedRoleOption) {
      user.userRoleId = selectedRoleOption.value;
    }
    else {
      user.userRoleId = roleConstants.GUEST;
    }
    if (selectedLanguage && user.language != selectedLanguage.value) {
      user.language = selectedLanguage.value;
    }

    if (addMode) {
      delete user.id;
      user.emailVerified = true;
      dispatch(userActions.add(user));

    }
    else {

      if (user.password==""){
        delete user.password;
        delete user.passwordConfirm;
      }
      user.emailVerified = true;
      dispatch(userActions.edit(user));
    }
  }

  render() {

    const { t } = this.props;
    const { addMode, loading, user, emailState, passwordState, selectedLanguage, selectedRoleOption } = this.state;
    const { id, email, password, name, group, surname, language, parent_id, emailVerified, passwordConfirm, dbwork_name, isActive } = user;

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Modal isOpen={this.state.modalNotice} className="modal-notice" >
            <ModalHeader
              className="title-up"
            >
              {t("ERRORE")}
            </ModalHeader>
            <ModalBody>
              <ReactJson src={this.state.error} />
            </ModalBody>
            <ModalFooter className="justify-content-center">
              <Button
                color="info"
                round
                onClick={() => { this.setState({ modalNotice: false }) }}
              >
                OK
              </Button>
            </ModalFooter>
          </Modal>
          <Row>
            <Col md={12} xs={12}>
              <Card>
                <CardHeader>
                  <CardTitle>{(addMode ? t("Aggiungi utente") : t("Modifica utente") + " "+name)}
                    {loading && <img alt="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />}
                  </CardTitle>
                </CardHeader>
                <Form className="form-horizontal" onSubmit={this.handleSubmit}>
                  <CardBody>
                    {!addMode && <Row>
                      <Label sm={2}>ID</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup>
                          <Input
                            type="text"
                            disabled
                            placeholder=""
                            value={id}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    }

                    <Row>
                      <Label sm={2}>{t("Email")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className={emailState}>
                          <Input
                            type="text"
                            value={email}
                            name='email'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Password")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className={passwordState}>
                          <Input
                            type="password"
                            value={password}
                            name='password'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Conferma password")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className={this.state.passwordState}>
                          <Input
                            type="password"
                            value={passwordConfirm}
                            name='passwordConfirm'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Nome")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className={this.state.nameState}>
                          <Input
                            type="text"
                            value={name}
                            name='name'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Label sm={2}>{t("Cognome")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup className={this.state.surnameState}>
                          <Input
                            type="text"
                            value={surname}
                            name='surname'
                            onChange={this.handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Label sm={2}>{t("Lingua")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup>
                        <Select
                            className="primary"
                            placeholder={t("Lingua")}
                            name="language"
                            value={selectedLanguage}
                            options={this.languageOptions}
                            onChange={option =>
                              this.setState({ selectedLanguage: option })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label sm={2}>{t("Ruolo")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup>
                          <Select
                            className="primary"
                            placeholder={t("Ruolo")}
                            name="group"
                            value={selectedRoleOption}
                            options={this.roleOptions}
                            onChange={option =>
                              this.setState({ selectedRoleOption: option })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Label className="col-form-label" sm={2}>{t("Attivo")}</Label>
                      <Col xs={12} sm={7}>
                        <FormGroup style={ { paddingTop: 9}}>
                        <Switch
                            onText={<i className="now-ui-icons ui-1_check" />}
                            offText={
                              <i className="now-ui-icons ui-1_simple-remove" />
                            }
                            onColor={ "green" }
                            offColor={ "lightgray" }
                            onChange={(el, state) => { 
                              user.isActive = state;
                              this.setState({ user });
                            } }
                            value={isActive}
                          />                            
                            

                        </FormGroup>
                      </Col>
                    </Row>


                  </CardBody>
                  <CardFooter className="text-right">
                    <Button
                      color="success"
                    >
                      {t("Salva")}
                    </Button>
                    &nbsp;&nbsp;
                    <Link to={"/users"} onClick={this.onClickCancel}>
                      <Button color="default">{t("Annulla")}</Button>
                    </Link>

                  </CardFooter>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loopback } = state;
  const { users } = loopback;
  return {
    user: users && users.instance,
    error: users && users.error
  };
}

const connectedUserEdit = withTranslation()(connect(mapStateToProps)(UserEdit));
export { connectedUserEdit as UserEdit };


// WEBPACK FOOTER //
// ./src/views/Users/UserEdit.jsx